const React = require('react');
const { useContext } = React;
require('./App.scss');
const { GeneralContext } = require("./contexts/GeneralContext");

const App = () => {
    const {langDir} = useContext(GeneralContext);

    return (
        <div className={`App ${langDir}`}>
            You can use this server only from our website.
            <url>https://frontline.io/</url>
        </div>
    );
}

export default App;
